import axios from "axios";
import EventBus from "../common/EventBus";


const API_BACKEND_URL = "https://www.smartelec.eu.org/app_back/";

const getSettingsDevice = async (mac_custom) => {

  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const url = `${API_BACKEND_URL}get_device_settings_by_mac?mac_custom=` + mac_custom;

  return axios.get(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};


const getPerfsRaceDevicesActivity = async () => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const url = `${API_BACKEND_URL}mqtt_race_activity`

  return axios.get(url, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};


const startRace = async (users, circuitId, nbLapsOfRace) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`
  };

  const body = {
    users: users,
    circuitId: circuitId,
    nbLapsOfRace: nbLapsOfRace
  }
  console.log("backend.service / startRace");


  return axios.post(API_BACKEND_URL + "race_start", body, { headers }).then((response) => {
    return response;
  });
};

const stopRace = async (users, circuitId, raceId) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`
  };

  const body = {
    users: users,
    circuitId: circuitId,
    id: raceId
  }
  console.log("backend.service / stopRace");


  return axios.post(API_BACKEND_URL + "race_stop", body, { headers }).then((response) => {
    return response;
  });
};



const DatabaseService = {
  getSettingsDevice,
  getPerfsRaceDevicesActivity,
  startRace,
  stopRace,
}

export default DatabaseService;
